import { render } from "./RequisitionsTab.vue?vue&type=template&id=86190ef8"
import script from "./RequisitionsTab.vue?vue&type=script&lang=js"
export * from "./RequisitionsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__